/*
 * @Author: zhujian 
 * @Date: 2019-09-16 11:31:00 
 * @Last Modified by: zhujiapeng
 * @Last Modified time: 2021-01-13 15:15:00
 */


import React from 'react';
import './outline.less';

const Outline = () => {
  const list = ['leftTop', 'rightTop', 'rightBottom', 'leftBottom'];
  return (
    <React.Fragment>
      {
        list.map((item, index) => {
          return <div key={index} className={`${item} outline`}></div>
        })
      }
    </React.Fragment >
  );
}

export default Outline;
